import { IconPhoto, IconPlayerPlay } from "@repo/ui/icons";
import styles from "@styles/site.module.css";

type MediaPlaceholderProps = {
  /** Describes the media; used as the image alt text once `src` is set. */
  label: string;
  /** Real screenshot to show in place of the placeholder (e.g. "/null/screenshots/vhal.png"). */
  src?: string;
  kind?: "screenshot" | "animation" | "loop";
  ratio?: string;
  fill?: boolean;
};

export function MediaPlaceholder({ label, src, kind = "screenshot", ratio, fill }: MediaPlaceholderProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={label}
        loading="lazy"
        className={`${styles.mediaImage} ${fill ? styles.mediaPlaceholderFill : ""}`}
        style={ratio ? { aspectRatio: ratio } : undefined}
      />
    );
  }
  const Icon = kind === "screenshot" ? IconPhoto : IconPlayerPlay;
  return (
    <div
      className={`${styles.mediaPlaceholder} ${fill ? styles.mediaPlaceholderFill : ""}`}
      style={ratio ? { aspectRatio: ratio } : undefined}
      role="img"
      aria-label={`${kind} placeholder: ${label}`}
    >
      <Icon size={22} stroke={1.5} className={styles.mediaPlaceholderIcon} />
      <span className={styles.mediaPlaceholderKind}>{kind}</span>
      <span className={styles.mediaPlaceholderLabel}>{label}</span>
    </div>
  );
}
